import {
  FETCH_ENGLISH_KEYWORDS,
  FETCH_ENGLISH_KEYWORDS_SUCCESS,
  FETCH_ENGLISH_KEYWORDS_FAILED,
  SAVE_KEYWORDS_SUGGESTIONS,
  SAVE_KEYWORDS_SUGGESTIONS_SUCCESS,
  SAVE_KEYWORDS_SUGGESTIONS_FAILED,
  FETCH_KEYWORD_AUDIT,
  FETCH_KEYWORD_AUDIT_SUCCESS,
  FETCH_KEYWORD_AUDIT_FAILED,
  SAVE_KEYWORDS_AUDIT,
  SAVE_KEYWORDS_AUDIT_SUCCESS,
  SAVE_KEYWORDS_AUDIT_FAILED,
  SAVE_KEYWORD,
  SAVE_KEYWORD_SUCCESS,
  SAVE_KEYWORD_FAILED,
  API_URL,
} from "./../constants/constants";
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

function* fetchEnglishKeywords(action) {
  const { userId } = action;
  // const { object: { username,start_date, end_date, start_page, end_page } } = action
  // const toPost = {
  //    user:username,
  //    start_date,
  //    end_date,
  //    start_page,
  //    end_page
  // }

  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/get-english-keyword?userId=${userId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
    );
    yield put({ type: FETCH_ENGLISH_KEYWORDS_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: FETCH_ENGLISH_KEYWORDS_FAILED, data: "error" });
  }
}

function* saveKeywordSuggestions(action) {
  const { keyword, possibleWords, userId } = action.suggestionObj;
  const toPost = {
    keyword_id: keyword,
    possible_words: possibleWords,
    user_id: userId,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/generate-keyword-language-wise`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: SAVE_KEYWORDS_SUGGESTIONS_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: SAVE_KEYWORDS_SUGGESTIONS_FAILED, data: error });
  }
}

function* saveKeyword(action) {
  const { userId, productId, language, keyword } = action.payload;
  const toPost = {
    Keyword: keyword,
    Language: language,
    ProductId: productId,
    CreatedBy: userId,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/Keyword-Build-Details`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: SAVE_KEYWORD_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: SAVE_KEYWORD_FAILED, data: error });
  }
}

function* fetchKeywordsAudit(action) {
  const { userId } = action;
  const toPost = {
    user_id: userId,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/get-keyword-audit`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_KEYWORD_AUDIT_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: FETCH_KEYWORD_AUDIT_FAILED, data: "error" });
  }
}

function* saveKeywordAudit(action) {
  const { userId, Possibleword, id } = action.auditObj;
  const toPost = {
    user_id: userId,
    Possibleword: Possibleword,
    id,
  };

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/update-new-keyword-update`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: SAVE_KEYWORDS_AUDIT_SUCCESS, data: result.data });
    yield put({ type: FETCH_KEYWORD_AUDIT, userId: userId });
  } catch (error) {
    yield put({ type: SAVE_KEYWORDS_AUDIT_FAILED, data: error });
  }
}

function* creatorSagas() {
  yield takeLatest(FETCH_ENGLISH_KEYWORDS, fetchEnglishKeywords);
  yield takeLatest(SAVE_KEYWORDS_SUGGESTIONS, saveKeywordSuggestions);
  yield takeLatest(FETCH_KEYWORD_AUDIT, fetchKeywordsAudit);
  yield takeLatest(SAVE_KEYWORDS_AUDIT, saveKeywordAudit);
  yield takeLatest(SAVE_KEYWORD, saveKeyword);
  // yield takeLatest(LOGIN, isUserLoggedIn)
  // yield takeLatest(UPLOAD_FILE_REQUEST,isAudioUploaded)
}

export default creatorSagas;
